import { Route, Switch } from 'react-router-dom';
import SettingsPage from './SettingsPage';

export default function Routes() {
  return (
    <Switch>
      <Route path="/settings" component={SettingsPage} />
    </Switch>
  );
}
